import type { NewsItem } from "@/types/media";

export const newsTags = ["全部", "行业动态", "新片定档", "剧集资讯", "票房数据", "电影节", "市场观察"];

export const newsList: NewsItem[] = [
  {
    id: "n-001",
    title: "2026年度华语电影市场回暖，多部类型佳作集中定档",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20cinema%20lobby%20with%20warm%20lighting%20and%20movie%20poster%20wall%2C%20editorial%20photography%2C%20clean%20composition%2C%20no%20text&width=800&height=500&seq=mogu-news-01&orientation=landscape",
    date: "2026-10-15",
    author: "蘑菇编辑部",
    source: "蘑菇MOGU2 资讯",
    tags: ["行业动态", "市场观察"],
    summary:
      "进入十月，多部国产类型片陆续公布档期，科幻、悬疑、剧情题材齐发力，业内普遍看好第四季度票房表现。",
    content: [
      "随着国庆档落幕，2026 年的华语电影市场交出了一份超出预期的成绩单。据多方统计，前三季度国产影片票房占比稳步提升，类型化创作趋势愈发明显。",
      "在接下来的一段时间里，科幻片《星际回响》、战争题材《铁血苍穹》以及悬疑片《雾城迷案》等作品将陆续与观众见面，覆盖不同年龄层的观影需求。",
      "多位影院经理表示，观众对“讲得好故事”的作品越来越买账，口碑对票房的拉动作用显著增强。与此同时，中小成本影片也通过精准的类型定位找到了自己的观众。",
      "业内人士分析，第四季度有望延续这一势头，为全年市场画上较为圆满的句号。",
    ],
  },
  {
    id: "n-002",
    title: "科幻新作《星际回响》口碑爆棚，首周票房表现亮眼",
    cover:
      "https://readdy.ai/api/search-image?query=cosmic%20nebula%20and%20planet%20in%20deep%20space%20with%20dramatic%20blue%20and%20amber%20light%2C%20editorial%20photography%2C%20no%20text&width=800&height=500&seq=mogu-news-02&orientation=landscape",
    date: "2026-10-12",
    author: "影评组",
    source: "蘑菇MOGU2 资讯",
    tags: ["新片定档", "票房数据"],
    summary:
      "《星际回响》上映首周凭借扎实的科幻设定与情感内核收获大量好评，社交平台讨论度持续走高。",
    content: [
      "由陆沉执导的科幻电影《星际回响》自上映以来，凭借严谨的设定和细腻的人物刻画收获了大量正面评价。",
      "不少观众表示，影片在宏大的宇宙叙事之中，始终没有丢掉对“人”的关注，这也是它区别于部分同类作品的关键。",
      "影片的视觉呈现同样获得认可，深空场景与音效设计被评价为“沉浸感十足”。随着口碑持续发酵，后续排片有望进一步增加。",
    ],
  },
  {
    id: "n-003",
    title: "悬疑剧《暗涌之城》收官，现实题材再掀讨论热潮",
    cover:
      "https://readdy.ai/api/search-image?query=rainy%20city%20skyline%20at%20night%20with%20deep%20blue%20tones%20and%20neon%20reflections%2C%20editorial%20photography%2C%20no%20text&width=800&height=500&seq=mogu-news-03&orientation=landscape",
    date: "2026-10-09",
    author: "剧集观察",
    source: "蘑菇MOGU2 资讯",
    tags: ["剧集资讯", "行业动态"],
    summary:
      "《暗涌之城》以扎实的群像刻画和层层递进的叙事收官，围绕现实议题的讨论在观众中持续发酵。",
    content: [
      "本季度最受关注的悬疑剧之一《暗涌之城》正式收官。该剧以一座城市的资本暗流为背景，通过记者与警察的双线视角推进故事。",
      "与许多同类作品不同，该剧并未过度依赖反转，而是把重心放在了人物动机与社会语境上，让观众在追凶之外看见更真实的人性。",
      "收官之后，关于剧中议题的讨论仍在延续，不少观众表示希望能够看到第二季。",
    ],
  },
  {
    id: "n-004",
    title: "国际电影节公布入围名单，多部华语作品榜上有名",
    cover:
      "https://readdy.ai/api/search-image?query=film%20festival%20red%20carpet%20venue%20at%20night%20with%20elegant%20lighting%2C%20editorial%20photography%2C%20no%20text&width=800&height=500&seq=mogu-news-04&orientation=landscape",
    date: "2026-10-05",
    author: "国际组",
    source: "蘑菇MOGU2 资讯",
    tags: ["电影节", "行业动态"],
    summary:
      "本届国际电影节公布入围名单，多部华语剧情片与纪录片入围主竞赛及新导演单元。",
    content: [
      "本届国际电影节近日公布入围名单，华语电影在多个单元中均有斩获，涵盖剧情、纪录片与新导演扶持计划。",
      "其中，聚焦家庭与迁徙议题的剧情片获得主竞赛单元提名，被认为是最具竞争力的作品之一。",
      "业内人士指出，近年华语作品在叙事视角与国际表达上愈发成熟，在海外影展的能见度稳步提升。",
    ],
  },
  {
    id: "n-005",
    title: "经典题材焕新，《大宋提刑录》第二季正式官宣",
    cover:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20city%20rooftops%20at%20dusk%20with%20lantern%20lights%2C%20editorial%20photography%2C%20no%20text&width=800&height=500&seq=mogu-news-05&orientation=landscape",
    date: "2026-09-28",
    author: "剧集观察",
    source: "蘑菇MOGU2 资讯",
    tags: ["剧集资讯", "新片定档"],
    summary:
      "古装探案剧《大宋提刑录》宣布续订第二季，原班人马有望回归，新案件线索同步曝光。",
    content: [
      "凭借扎实的探案逻辑与考究的时代细节，《大宋提刑录》成为今年口碑表现最突出的古装剧之一。官方宣布将启动第二季制作。",
      "制作方透露，第二季将继续沿用单元案件结构，同时强化主线，主角的过往与朝堂之争将成为新的看点。",
      "目前剧本已进入打磨阶段，具体档期尚未公布。",
    ],
  },
  {
    id: "n-006",
    title: "动画电影成档期黑马，合家欢类型迎来新机遇",
    cover:
      "https://readdy.ai/api/search-image?query=colorful%20animated%20movie%20concept%20art%20with%20whimsical%20shapes%20and%20warm%20light%2C%20editorial%20photography%2C%20no%20text&width=800&height=500&seq=mogu-news-06&orientation=landscape",
    date: "2026-09-20",
    author: "市场组",
    source: "蘑菇MOGU2 资讯",
    tags: ["市场观察", "票房数据"],
    summary:
      "多部动画电影在档期内表现抢眼，合家欢类型逐渐成为档期票房的重要支撑。",
    content: [
      "本年度多个档期中，动画电影的表现格外亮眼，多部作品凭借扎实的故事与精良制作吸引了大量家庭观众。",
      "分析认为，随着亲子观影需求增长，合家欢类型的市场空间正在扩大，制作方也开始在题材与表达上做更多尝试。",
      "不过，业内也提醒，动画电影的成功依旧高度依赖品质与口碑，题材红利并不能替代内容本身。",
    ],
  },
  {
    id: "n-007",
    title: "新生代演员崭露头角，演技派回归成行业关键词",
    cover:
      "https://readdy.ai/api/search-image?query=theater%20stage%20with%20warm%20spotlight%20and%20empty%20rows%20of%20seats%2C%20editorial%20photography%2C%20no%20text&width=800&height=500&seq=mogu-news-07&orientation=landscape",
    date: "2026-09-12",
    author: "人物组",
    source: "蘑菇MOGU2 资讯",
    tags: ["行业动态", "市场观察"],
    summary:
      "越来越多年轻演员凭借扎实表演获得认可，行业对演技与作品质量的重视程度明显提升。",
    content: [
      "过去一年里，一批新生代演员凭借在剧集与电影中的稳定表现进入大众视野，成为讨论度最高的群体之一。",
      "与以往不同，观众对演员的关注正在从“流量”转向“作品与角色”。这也让更多注重表演的年轻面孔获得了机会。",
      "多位导演表示，选角时更加看重演员与角色的契合度，而非单纯的知名度，这被视为行业回归内容本身的积极信号。",
    ],
  },
  {
    id: "n-008",
    title: "流媒体加大原创内容投入，剧集市场竞争格局生变",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20streaming%20studio%20with%20screens%20and%20warm%20ambient%20lighting%2C%20editorial%20photography%2C%20no%20text&width=800&height=500&seq=mogu-news-08&orientation=landscape",
    date: "2026-09-05",
    author: "行业观察",
    source: "蘑菇MOGU2 资讯",
    tags: ["行业动态", "剧集资讯"],
    summary:
      "多家流媒体平台宣布加大原创剧集投入，短剧与精品剧并行，市场竞争进入新阶段。",
    content: [
      "近期，多家流媒体平台相继公布新一季度的内容规划，原创剧集的投入规模进一步扩大，短剧与精品长剧成为两条并行赛道。",
      "平台方表示，用户对内容质量的要求在不断提升，只有真正具备辨识度的作品才能留住观众。",
      "与此同时，制作公司与平台之间的合作模式也在调整，从单纯的采购走向更深度的联合开发。",
    ],
  },
];